module.exports = {"542424100":"聂荣镇","542424200":"尼玛乡","542424201":"查当乡","542424202":"当木江乡","542424203":"永曲乡","542424204":"索雄乡","542424205":"白雄乡","542424206":"桑荣乡","542424207":"下曲乡","542424208":"色庆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542424.json
// module id = 2897
// module chunks = 0